import { IEvent } from "../../../../models/Event"

export const Results: React.FC<{ event: IEvent }> = ({ event }) => {
    return (
        <div className="resaluts-container">
            <h2 className="panel-title">תוצאות</h2>
            <a className="btn btn-primary" href={event.resultsUrl}>לחץ לתוצאות</a>
        </div >
    )
}
